import menu from '@/components/menu/list'
let routes = [
  {
    path: '/menu',
    name: 'menu',
    component: menu,
    meta: {
      requiresAuth: true
    }
  }
]
export default { routes }



// WEBPACK FOOTER //
// ./src/router/menu.js